import type {HttpClient} from '@sollapay/http-client';
import type {ApiResponse, MunicipalAuthorityDTO} from '@sollapay/types';

export const municipalAuthoritiesApi = {
  fetchMunicipalAuthorities: (client: HttpClient): Promise<ApiResponse<MunicipalAuthorityDTO[]>> =>
    client.get<ApiResponse<MunicipalAuthorityDTO[]>>('/municipal-authorities')
};
